import React, { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../../muiComponents/Icon';
import '../../stylesheets/stylesLayout/lateralMenu.scss';
import useUserProfile from '../../customHooks/useUserProfile';
import {
    getOwnerPortalMenu,
    getZinantisMenu,
    getZitoneoMenu,
} from '../../utils/menusData';
import { useAppConfigurationSections } from '../../contexts/AppConfigurationContext';
import useTranslate from '../../customHooks/useTranslate';

const OwnerPortalLateralMenu = () => {
    const { settings } = useUserProfile();
    const { adminUser } = settings;
    const translate = useTranslate();
    const [isOpenMenu, setIsOpenMenu] = useState(true);

    const {
        zinantis,
        core,
        isCoreSectionVisible,
        isZinantisSectionVisible,
        zitoneo,
        isZitoneoSectionVisible,
    } = useAppConfigurationSections();

    const zinantisMenu = useMemo(
        () =>
            getZinantisMenu(
                isZinantisSectionVisible,
                adminUser,
                zinantis.pages
            ),
        [isZinantisSectionVisible, adminUser, zinantis.pages]
    );

    const ownerPortalMenu = useMemo(
        () => getOwnerPortalMenu(isCoreSectionVisible, core.pages),
        [isCoreSectionVisible, core.pages]
    );

    const zitoneoMenu = useMemo(
        () => getZitoneoMenu(isZitoneoSectionVisible, adminUser, zitoneo.pages),
        [isZitoneoSectionVisible, adminUser, zitoneo.pages]
    );

    return (
        <nav
            className={`menu-list__container ${
                isOpenMenu ? '--expanded' : '--collapsed'
            }`}
        >
            <div className='menu-list'>
                {ownerPortalMenu.length ? (
                    <div>
                        <h6
                            className={`menu-list__title ${
                                isOpenMenu ? '' : '--collapsed'
                            }`}
                        >
                            {translate('dashboard')}
                        </h6>
                        <ul>
                            {ownerPortalMenu.map((item, i) => {
                                const { link, text, icon } = item;

                                return (
                                    <li key={i} className='menu__item'>
                                        <NavLink
                                            to={link}
                                            className='menu-item__link'
                                        >
                                            <Icon
                                                iconName={icon}
                                                className='menu-item__icon'
                                                fontSize='medium'
                                            />
                                            <span className='menu-item__text'>
                                                {translate(text)}
                                            </span>
                                        </NavLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ) : (
                    ''
                )}
                {zinantisMenu.length ? (
                    <div>
                        <h6
                            className={`menu-list__title ${
                                isOpenMenu ? '' : '--collapsed'
                            }`}
                        >
                            zinantis
                        </h6>
                        <ul>
                            {zinantisMenu
                                .filter(
                                    item => zinantis.pages[item.visibilityKey]
                                )
                                .map((item, i) => {
                                    const { link, text, icon } = item;
                                    return (
                                        <li key={i} className='menu__item'>
                                            <NavLink
                                                to={link}
                                                className='menu-item__link'
                                            >
                                                <Icon
                                                    iconName={icon}
                                                    className='menu-item__icon'
                                                    fontSize='medium'
                                                />
                                                <span className='menu-item__text'>
                                                    {translate(text)}
                                                </span>
                                            </NavLink>
                                        </li>
                                    );
                                })}
                        </ul>
                    </div>
                ) : (
                    ''
                )}
                {zitoneoMenu.length ? (
                    <div>
                        <h6
                            className={`menu-list__title ${
                                isOpenMenu ? '' : '--collapsed'
                            }`}
                        >
                            zitoneo
                        </h6>
                        <ul>
                            {zitoneoMenu
                                .filter(
                                    item => zitoneo.pages[item.visibilityKey]
                                )
                                .map((item, i) => {
                                    const { link, text, icon } = item;
                                    return (
                                        <li key={i} className='menu__item'>
                                            <NavLink
                                                to={link}
                                                className='menu-item__link'
                                                target={item.target || '_self'}
                                            >
                                                <Icon
                                                    iconName={icon}
                                                    className='menu-item__icon'
                                                    fontSize='medium'
                                                />
                                                <span className='menu-item__text'>
                                                    {translate(text)}
                                                </span>
                                            </NavLink>
                                        </li>
                                    );
                                })}
                        </ul>
                    </div>
                ) : (
                    ''
                )}
            </div>
            <Icon
                iconName='KeyboardArrowLeft'
                className={`menu__colapse-icon ${
                    isOpenMenu ? '--expanded' : '--collapsed'
                }`}
                onClick={() => setIsOpenMenu(prev => !prev)}
            />
        </nav>
    );
};

export default OwnerPortalLateralMenu;
